/** "Pages 1–5", "Pages 1–3, 5", "Page 4". */
export function formatPages(pages: number[]): string {
  if (pages.length === 0) return 'No pages'
  const sorted = [...pages].sort((a, b) => a - b)
  const ranges: string[] = []
  let start = sorted[0]
  for (let i = 1; i <= sorted.length; i++) {
    if (sorted[i] === sorted[i - 1] + 1) continue
    const end = sorted[i - 1]
    ranges.push(start === end ? `${start}` : `${start}–${end}`)
    start = sorted[i]
  }
  return `${sorted.length === 1 ? 'Page' : 'Pages'} ${ranges.join(', ')}`
}
